import useImageUpload from './useImageUpload';

const useImageUploadStore = useImageUpload();

export default useImageUploadStore;
